import { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Icon } from 'src/components';
import { PageTemplate } from '../pageTemplates';
import * as S from './styles';

const msgs = defineMessages({
  freeHeader: { id: 'onboarding_upsell_plan_free_title' },
  proHeader: { id: 'onboarding_upsell_plan_pro_title' },
  disclaimer: { id: 'plans_page_v4_caveat' },
});

export const BenefitsSection: FC<{
  pageTemplate: PageTemplate;
}> = ({ pageTemplate }) => {
  const intl = useIntl();

  return (
    <S.SectionWrapper>
      <S.Table>
        <thead>
          <S.Row>
            <S.HeaderCell />
            <S.HeaderCell>
              <S.HeaderCellContent>
                <S.FreeHeaderText>{intl.formatMessage(msgs.freeHeader)}</S.FreeHeaderText>
              </S.HeaderCellContent>
            </S.HeaderCell>
            <S.HeaderCell>
              <S.HeaderCellContent $isPro>{intl.formatMessage(msgs.proHeader)}</S.HeaderCellContent>
            </S.HeaderCell>
          </S.Row>
        </thead>

        <tbody>
          {pageTemplate.benefits.map((benefit, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <S.Row key={`benefit-${index}`}>
              <S.Cell>
                <S.FeatureCellContent>
                  {intl.formatMessage({ id: benefit.messageId })}
                </S.FeatureCellContent>
              </S.Cell>
              <S.Cell>
                {benefit.isFree && (
                  <S.CheckmarkCellContent>
                    <Icon name="check" aria-label={intl.formatMessage(msgs.freeHeader)} />
                  </S.CheckmarkCellContent>
                )}
              </S.Cell>
              <S.Cell>
                <S.CheckmarkCellContent>
                  <Icon name="check" aria-label={intl.formatMessage(msgs.proHeader)} />
                </S.CheckmarkCellContent>
              </S.Cell>
            </S.Row>
          ))}
        </tbody>
      </S.Table>
      <S.Disclaimer>{intl.formatMessage(msgs.disclaimer)}</S.Disclaimer>
    </S.SectionWrapper>
  );
};

export default BenefitsSection;
